export function normalizePhone(raw?: string | null): string | null {
    let d = (raw || "").replace(/\D/g, "");
    if (d.startsWith("00")) d = d.slice(2);
    if (d.length === 10 && d.startsWith("0")) d = "994" + d.slice(1);
    return d.length >= 8 && d.length <= 15 ? d : null;
}

export function formatPhone(digits: string): string {
    if (digits.startsWith("994") && digits.length === 12) {
        const r = digits.slice(3);
        return `+994 ${r.slice(0, 2)} ${r.slice(2, 5)} ${r.slice(5, 7)} ${r.slice(7)}`;
    }
    return `+${digits}`;
}

export const waMeUrl = (digits: string, text = "") =>
    `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const WA_GREEN = "#25D366";
export const WA_EVENT = "user-wa-changed";
